import {whiteLabelStore} from "./white-label/white-label.slice.js";
export default {
  ...whiteLabelStore.actions
};
